/**
 * @material-table/core treats non-array data as a remote query function.
 * Always normalize API payloads before passing them to the data prop.
 */
export function asMaterialTableData(data) {
  if (Array.isArray(data)) {
    return data;
  }
  if (data && Array.isArray(data.items)) {
    return data.items;
  }
  return [];
}

export function materialTableTotalCount(data) {
  if (Array.isArray(data)) {
    return data.length;
  }
  return data?.count ?? 0;
}
